import template from './impersonateModal.html';
import controller from './impersonateModal.controller';

let ImpersonateModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-success animated zoomIn"
};

export default ImpersonateModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/impersonateModal/impersonateModal.component.js